import { useEffect, useState } from "react";
import { fetchHistorical } from "../lib/api";

/**
 * Encapsulates fetching the daily-close historical series for `ticker`
 * over `days` days. Cancels in-flight requests when inputs change.
 *
 * @param {Object|null} ticker  Slickcharts ticker row (must expose `.symbol`)
 * @param {number}      days    Window length, e.g. 250
 * @param {boolean}     enabled Gate (e.g. drawer open flag)
 * @returns {{ history: Object|null, error: Error|null, loading: boolean }}
 */
export function useHistory(ticker, days, enabled) {
  const [history, setHistory] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!ticker || !enabled) {
      setHistory(null);
      setError(null);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setError(null);
    setLoading(true);

    fetchHistorical(ticker.symbol, days)
      .then((d) => {
        if (!cancelled) setHistory(d);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [ticker, days, enabled]);

  return { history, error, loading };
}
